import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { userContext } from "../../App";
import "./Book.css";
import FakeData from "../FakeData/FakeData.json";
import SearchResult from "../SearchResult/SearchResult";
import GoogleMap from "../GoogleMap/GoogleMap";

const Book = () => {
  const { bookType } = useParams();
  const [loggedInUser, setLoggedInUser] = useContext(userContext);
  const [Vehicle, setVehicle] = useState({
    name: "",
    image: "",
    price: "",
    parson: "",
    fromValid: false,
    from: "",
    to: "",
  });
  useEffect(() => {
    const { type, money, img, parson } = FakeData.find(
      (element) => element.type === bookType
    );
    let info = { ...Vehicle };
    info = {
      image: img,
      price: money,
      parson: parson,
      type: type,
    };
    setVehicle(info);
  }, []);
  const handelSubmit = (e) => {
    const vehicleInfo = { ...Vehicle };
    vehicleInfo.fromValid = true;
    setVehicle(vehicleInfo);
    e.preventDefault();
  };
  const handelBlur = (e) => {
    const vehicleInfo = { ...Vehicle };
    if (e.target.name === "from") {
      vehicleInfo[e.target.name] = e.target.value;
    }
    if (e.target.name === "to") {
      vehicleInfo[e.target.name] = e.target.value;
    }
    setVehicle(vehicleInfo);
  };

  return (
    <div className=" mt-5 pt-5 ">
      {Vehicle.fromValid ? (
        <SearchResult vehicle={Vehicle}></SearchResult>
      ) : (
        <div className="row">
          <div className="col-md-4 input">
            <h2 className="mt-3">Pick Up</h2>
            <form onSubmit={handelSubmit}>
              <input
                onBlur={handelBlur}
                style={{ width: "320px" }}
                className="input-box"
                placeholder="Type here"
                type="text"
                name="from"
                required
              />
              <br />
              <h2 className="mt-3">Pick To</h2>
              <input
                onBlur={handelBlur}
                style={{ width: "320px" }}
                className="input-box mb-3"
                placeholder="Type here"
                type="text"
                name="to"
                required
              />
              <br />
              <input className="main-btn mb-3" type="submit" value="Search" />
            </form>
          </div>
          <div className="col-m-8">
            <GoogleMap></GoogleMap>
          </div>
        </div>
      )}
    </div>
  );
};

export default Book;
